import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../components/AppAnimate";
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import Button from "@mui/material/Button";
import Container from '@mui/material/Container';
import {Box, Typography, useMediaQuery} from "@mui/material";
import {MoveRight, ChevronRight, CircleCheckBig, Download, UserRound, Store} from "lucide-react";
import Title from "../../../components/elements/Title";
import AddressChooserFieldHome from "../../../components/address/AddressChooserFieldHome";
import Market from '../../../../files/img/icons/market.png'
import Restaurant from '../../../../files/img/icons/restaurant.png'
import App from '../../../../files/img/icons/app.png'
import IOSImg from "../../../../files/img/apps/ios.png";
import AndroidImg from "../../../../files/img/apps/android.png";
import {connect, setStore} from "trim-redux";
import {Link} from 'react-router-dom';
import HomePageSkeleton from "../../../components/loaders/HomePageSkeleton";
import AppUser from '../../../../files/img/apps/app-user.png'
import AppSupplier from '../../../../files/img/apps/app-supplier.png'
import AppCourier from '../../../../files/img/apps/app-courier.png'
import Courier from "../../../components/icons/Courier";
import {theme} from "../../../../config/design/theme";

function AppPage({classes, setting}){
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const translate = {
        mobileApp:'Mobil Uygulama',
        mobileAppDesc:'Kullanım kolaylığı için Android uygulamalarını burada bulabilir, kullanım türünüze göre ilgili Android uygulamasını indirebilirsiniz.',
        userAppDesc:'Android uygulamasıyla restoranlara ve mağazalara daha kolay ulaşın, sipariş verin ve kapınızda teslim alın',
        user1:"Kolay kayıt imkanı",
        user2:"Farklı adresler ekleme",
        user3:"Sipariş verme",
        user4:"Sipariş adımlarını görüntüle",
        userApp:'Kullanıcılar için uygulama',
        androidAppUsers:"Kullanıcılar için Android uygulaması",
        androidAppUsersDesc:"Daha kolay erişim için Android uygulamamızı indirebilirsiniz.",
        androidAppSupplier:"Restoranlar ve marketler için Android uygulaması",
        androidAppSupplierDesc:"Uygulama ile siparişlerinizi daha kolay takip edebilirsiniz.",
        supplier1:"Kullanımı kolay",
        supplier2:"Satış raporu paneli",
        supplier3:"Daha iyi sipariş yönetimi",
        supplier4:"İletişim yönetimi",
        supplierApp:'Satıcı için Uygulama',
        androidAppCourier:"Kurye için Android uygulaması",
        androidAppCourierDesc:"Uygulama ile yeni siparişlerden hızla haberdar olun.",
        courier1:"Daha Hızlı Bildirim",
        courier2:"Sipariş Yönetimi",
        courier3:"Daha İyi İletişim",
        courier4:"Lokasyonlara Daha İyi Erişim",
        courierApp:'Kurye için Uygulama'
    }
    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('downloadApp')}>

                <div className={classes.appPage}>
                    <Container maxWidth="xl" >
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item size={12}>
                                <Box className='top-title'>
                                    <Title color="#fff" className='p-top-title'>{translate.mobileApp}</Title>
                                    <Typography  color="#fff" className='p-top-desc' >{translate.mobileAppDesc}</Typography>
                                </Box>
                                <Grid container spacing={2} justifyContent="center" alignItems="center" className='app-box'>
                                    <Grid item size={{ xs: 12, md: 4, lg: 5 }} className='text-center'>
                                        <img src={AppUser} alt="img1" className="small-image image-app"/>
                                    </Grid>
                                    <Grid item size={{ xs: 12, md: 8, lg: 6 }}>
                                        <UserRound  className='lucide-icon-app '/>
                                        <Title align='left'>{translate.androidAppUsers}</Title>
                                        <Typography className='p-app-desc'>{translate.androidAppUsersDesc}</Typography>
                                        <div className="flex-direction flex-column-lg" style={{gap:0}}>
                                            <div className='box-item'>
                                                <Typography>{translate.user1}</Typography>
                                            </div>
                                            <div className='box-item'>
                                                <Typography>{translate.user2}</Typography>
                                            </div>
                                        </div>
                                        <div className="flex-direction flex-column-lg" style={{gap:0}}>
                                            <div className='box-item'>
                                                <Typography>{translate.user3}</Typography>
                                            </div>
                                            <div className='box-item'>
                                                <Typography>{translate.user4}</Typography>
                                            </div>
                                        </div>
                                        <div className="btn-app-download-holder">
                                            <a  href={"https://apps.apple.com/app/id6751489510"} target="_blank" className="btn-app-download">
                                                <img src={IOSImg} alt='ios-app' loading="lazy" />
                                            </a>
                                            <a href={`https://play.google.com/store/apps/details?id=com.kolaydoy.kolaydoy`} target="_blank" className="btn-app-download">
                                                <img src={AndroidImg} alt='android-app' loading="lazy" />
                                            </a>
                                        </div>
                                    </Grid>
                                    <Grid item size={1}></Grid>
                                </Grid>
                                <Grid container spacing={2} justifyContent="center" alignItems="center" className='app-box'>
                                    <Grid item size={1}></Grid>
                                    {
                                        !!isMobile &&
                                        <Grid item size={{ xs: 12, md: 3, lg: 5 }} className='text-center'>
                                            <img src={AppSupplier} alt="img1" className="small-image image-app"/>
                                        </Grid>
                                    }
                                    <Grid item size={{ xs: 12, md: 8, lg: 6 }}>
                                        <Store  className='lucide-icon-app'/>
                                        <Title align='left'>{translate.androidAppSupplier}</Title>
                                        <Typography className='p-app-desc'>{translate.androidAppSupplierDesc}</Typography>
                                        <div className="flex-direction flex-column-lg" style={{gap:0}}>
                                            <div className='box-item'>
                                                <Typography>{translate.supplier1}</Typography>
                                            </div>
                                            <div className='box-item'>
                                                <Typography>{translate.supplier2}</Typography>
                                            </div>
                                        </div>
                                        <div className="flex-direction flex-column-lg" style={{gap:0}}>
                                            <div className='box-item'>
                                                <Typography>{translate.supplier3}</Typography>
                                            </div>
                                            <div className='box-item'>
                                                <Typography>{translate.supplier4}</Typography>
                                            </div>
                                        </div>
                                        <div className="btn-app-download-holder">
                                            <a  href={"https://apps.apple.com/app/id6751750376"} target="_blank" className="btn-app-download">
                                                <img src={IOSImg} alt='ios-app' loading="lazy" />
                                            </a>
                                            <a href={`https://play.google.com/store/apps/details?id=com.kolaydoy.kolaydoyvendors`} target="_blank" className="btn-app-download">
                                                <img src={AndroidImg} alt='android-app' loading="lazy" />
                                            </a>
                                        </div>
                                    </Grid>
                                    {
                                        !isMobile &&
                                        <Grid item size={{ xs: 12, md: 3, lg: 5 }} className='text-center'>
                                            <img src={AppSupplier} alt="img1" className="small-image image-app"/>
                                        </Grid>
                                    }
                                </Grid>
                                <Grid container spacing={2} justifyContent="center" alignItems="center" className='app-box' style={{marginBottom: 80}}>
                                        <Grid item size={{ xs: 12, md: 4, lg: 5 }} className='text-center'>
                                            <img src={AppCourier} alt="img1" className="small-image image-app" />
                                        </Grid>
                                    <Grid item size={{ xs: 12, md: 8, lg: 6 }}>
                                        <Courier  className='lucide-icon-app' fill="#F0051F"/>
                                        <Title align='left'>{translate.androidAppCourier}</Title>
                                        <Typography className='p-app-desc'>{translate.androidAppCourierDesc}</Typography>
                                        <div className="flex-direction flex-column-lg" style={{gap:0}}>
                                            <div className='box-item'>
                                                <Typography>{translate.courier1}</Typography>
                                            </div>
                                            <div className='box-item'>
                                                <Typography>{translate.courier2}</Typography>
                                            </div>
                                        </div>
                                        <div className="flex-direction flex-column-lg" style={{gap:0}}>
                                            <div className='box-item'>
                                                <Typography>{translate.courier3}</Typography>
                                            </div>
                                            <div className='box-item'>
                                                <Typography>{translate.courier4}</Typography>
                                            </div>
                                        </div>
                                        {/*<Button
                                            startIcon={<Download color="#fff" size={20}/> }
                                            variant="contained"
                                            className="btn-download"
                                            component={"a"}
                                            target="_blank"
                                            href={"https://play.google.com/store/apps/details?id=com.kolaydoy.kolaydoycouriers"}
                                            //href={`${defaultVariables.backend}uploads/apps/kolaydoy-courier-v${setting.current_version_android}.apk`}
                                        >
                                            {translate.courierApp}

                                        </Button>*/}
                                        <div className="btn-app-download-holder">
                                            <a  href={"https://apps.apple.com/app/kolaydoy-kurye/id6751745375"} target="_blank" className="btn-app-download">
                                                <img src={IOSImg} alt='ios-app' loading="lazy" />
                                            </a>
                                            <a href={"https://play.google.com/store/apps/details?id=com.kolaydoy.kolaydoycouriers"} target="_blank" className="btn-app-download">
                                                <img src={AndroidImg} alt='android-app' loading="lazy" />
                                            </a>
                                        </div>
                                    </Grid>
                                    <Grid item size={1}></Grid>

                                </Grid>
                            </Grid>
                        </Grid>
                    </Container>

                </div>

        </AppAnimate>
    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
    setting: state.setting,
});

export default withStyles(Styles)(connect(mapStateToProps)(AppPage));